'use strict';

var React = require('react');
require('prop-types');
var TimeSelector = require('./TimeSelector.js');
var Grid = require('../../node_modules/@material-ui/core/esm/Grid/Grid.js');
var Typography = require('../../node_modules/@material-ui/core/esm/Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function CheckboxWithDay(_ref) {
  var defaultChecked = _ref.defaultChecked,
      startTime = _ref.startTime,
      endTime = _ref.endTime,
      _onChange = _ref.onChange;
  return React__default["default"].createElement(Grid["default"], {
    container: true,
    justify: "space-between",
    alignItems: "center"
  }, React__default["default"].createElement(Grid["default"], {
    item: true
  }, React__default["default"].createElement(TimeSelector, {
    disabled: !defaultChecked,
    label: 'Open',
    time: startTime,
    onChange: function onChange(newTime) {
      _onChange('startTime', newTime);
    }
  })), React__default["default"].createElement(Grid["default"], {
    item: true
  }, React__default["default"].createElement(Typography["default"], {
    variant: "body1"
  }, "to")), React__default["default"].createElement(Grid["default"], {
    item: true
  }, React__default["default"].createElement(TimeSelector, {
    disabled: !defaultChecked,
    label: 'Close',
    time: endTime,
    onChange: function onChange(newTime) {
      _onChange('endTime', newTime);
    }
  })));
}

CheckboxWithDay.defaultProps = {
  onChange: function onChange() {}
};

module.exports = CheckboxWithDay;
